var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M5.17847 1H19.107C19.8459 1 20.5544 1.29349 21.0768 1.81592C21.5993 2.33834 21.8928 3.0469 21.8928 3.78571V13.5357",
    stroke: "#F3223C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary_2",
    d: "M21.8928 20.4999H7.96418C7.22536 20.4999 6.51681 20.2065 5.99438 19.684C5.47196 19.1616 5.17847 18.453 5.17847 17.7142V7.96423",
    stroke: "#F3223C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary_3",
    d: "M17.7144 9.35718L21.8929 13.5357L26.0715 9.35718",
    stroke: "#F3223C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary_4",
    d: "M9.35714 12.1428L5.17857 7.96423L1 12.1428",
    stroke: "#F3223C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusicon);
export default __webpack_public_path__ + "static/media/statusicon.a08ca3e31b9b67aed96d1ec199929970.svg";
export { ForwardRef as ReactComponent };